
import React from 'react';
import { Class } from '@/types/classTypes';

interface CalendarLegendProps {
  classes: Class[];
}

export const CalendarLegend: React.FC<CalendarLegendProps> = ({ classes }) => {
  // Get unique class names
  const uniqueClasses = Array.from(new Set(classes.map(cls => cls.name)));

  return (
    <div className="flex flex-wrap gap-2 mb-4 p-2 bg-white/50 backdrop-blur-sm rounded-lg border border-gray-100/60">
      <span className="text-sm font-medium text-muted-foreground mr-2">Legend:</span>
      {uniqueClasses.map((className) => {
        const colorClass = getEventColor(className);
        return (
          <div key={className} className="flex items-center">
            <div 
              className={`w-3 h-3 rounded-sm mr-1.5 ${colorClass.split(' ')[0]}`} 
            />
            <span className="text-sm text-muted-foreground">{className}</span>
          </div>
        );
      })}
    </div>
  );
};

// Import the getEventColor function from CalendarDayCell to maintain consistency
const getEventColor = (className: string): string => {
  const colors = {
    'Ballet': 'bg-pink-100 text-pink-700 border-pink-200',
    'Hip Hop': 'bg-yellow-100 text-yellow-700 border-yellow-200',
    'Painting': 'bg-green-100 text-green-700 border-green-200',
    'Music': 'bg-purple-100 text-purple-700 border-purple-200',
    'Dance': 'bg-blue-100 text-blue-700 border-blue-200',
    'default': 'bg-gray-100 text-gray-700 border-gray-200'
  };

  const matchingKey = Object.keys(colors).find(key => 
    className.toLowerCase().includes(key.toLowerCase())
  );
  return colors[matchingKey as keyof typeof colors] || colors.default;
};
